module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/WoqPpF/tc-custom/9781549304460.jpg?1728155712856",
      "alt": "This image is the cover for the book Accell Vol. 3: Turf Battles, Accell"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Accell Vol. 3: Turf Battles, Accell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Daniel Dos Santos just wants everything to go back to normal. His life is way too chaotic, and life would be much simpler if it would slow down. Too bad slowing down is the last thing he can do. Danny Dos Santos may be tired of being the superhero speedster Accell, but the superhero life isn’t easily ignored. When the criminal underworld is poised for a dramatic shakeup and military experiments rampage through the streets, you can’t just turn a blind eye, can you? Or is donning the suit just putting a target on his back for more prepared players?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joe Casey, Damion Scott, Robert Campanella, Sigmund Torre\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Joe Casey is an American comic book writer. He has worked on titles such as Wildcats 3.0, Uncanny X-Men, The Intimates, Adventures of Superman, and G.I. Joe: America's Elite among others. As part of the comics creator group Man of Action Studios, Casey is one of the creators of the animated series Ben 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Oni Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0